import { useMemo, useState } from "react";
import { useIntl } from "react-intl";
import useMeasure from "react-use-measure";
import { SimpleScene } from "@/model";
import { Typeahead, TypeaheadInput, TypeaheadOptions } from "@/component/input";


const BREAKPOINT_WIDTH = 150;

const sceneLabel = (scene?: SimpleScene) => scene ? `${scene.custom_id}: ${scene.name}` : "";
const findScene = (scenes: SimpleScene[], keyword?: string) => scenes.find(item => item.custom_id === keyword || sceneLabel(item) === keyword);

interface SceneTypeaheadProps {
    scenes: SimpleScene[];
    customId?: string;
    disabled?: boolean;
    onChange: (value: string) => void;
}

const SceneTypeahead: React.FC<SceneTypeaheadProps> = (props) => {
    const { scenes, customId, disabled = false, onChange } = props;
    const selectedScene = findScene(scenes, customId);

    const intl = useIntl();
    const [measureRef, { width: inputWidth }] = useMeasure();
    const [searchKeyword, setSearchKeyword] = useState(sceneLabel(selectedScene) || customId || "");

    const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.target.value.includes("{{")) {
            onChange(e.target.value);
        } else {
            const selectedByInput = findScene(scenes, e.target.value);
            if (selectedByInput) {
                onChange(selectedByInput.custom_id);
                setSearchKeyword(sceneLabel(selectedByInput));
            } else {
                setSearchKeyword(sceneLabel(selectedScene) || customId || "");
            }
        }
    };

    const filteredItems = useMemo(() => {
        return scenes.filter(item => sceneLabel(item).includes(searchKeyword));
    }, [scenes, searchKeyword]);

    return (
        <Typeahead ref={measureRef}
                   selection={sceneLabel(selectedScene)}
                   onChange={itemName => {
                       onChange(findScene(scenes, itemName)?.custom_id ?? "");
                       setSearchKeyword(itemName ?? "");
                   }}
        >
            <TypeaheadInput required
                            disabled={disabled}
                            value={searchKeyword}
                            placeholder={intl.formatMessage({ id: inputWidth < BREAKPOINT_WIDTH ? "i04025_1" : "i04025" })}
                            onChange={e => setSearchKeyword(e.target.value)}
                            onBlur={onBlur}
            />
            <TypeaheadOptions options={filteredItems.map(sceneLabel)} />
        </Typeahead>
    );
};

export default SceneTypeahead;
